export const VoiceDemoSkeleton = () => {
  return (
    <div
      className="font-ABCDiatype text-glass-800 relative flex w-full max-w-[900px] flex-col gap-4 rounded-[32px] bg-white p-4 @sm:p-6"
      data-testid="voice-demo-skeleton">
      {/* Top row */}
      <div className="flex flex-wrap items-center justify-between gap-4 @md:items-start">
        {/* Mobile: voice selector + language selector side by side */}
        {/* Desktop: voice selector only in this row */}
        <div className="flex w-full justify-between gap-2 @sm:w-auto">
          <div className="h-[50px] flex-1 animate-pulse rounded-2xl bg-[#F5F5FA] @sm:min-w-[160px] @sm:min-w-[260px] @sm:flex-none" />
          {/* Language selector - mobile only */}
          <div className="h-[50px] flex-1 animate-pulse rounded-2xl bg-[#F5F5FA] @sm:hidden" />
        </div>
        {/* Play + Download - desktop only in top row */}
        <div className="hidden w-full gap-2 @sm:flex @sm:w-auto">
          <div className="h-12 min-w-[133px] animate-pulse rounded-2xl bg-[#2F43FA]/20" />
          <div className="h-12 w-[134px] animate-pulse rounded-2xl border border-[#E9EAF0] bg-[#F5F5FA]" />
        </div>
      </div>

      {/* Divider */}
      <div className="mx-[-16px] hidden h-px bg-[#F5F5FA] @sm:mx-[-24px] @sm:block" />

      {/* Editor area */}
      <div className="flex flex-col @lg:flex-row @lg:gap-4">
        <div className="mb-2 flex-1 xl:w-11/12">
          <div className="h-[165px] w-full animate-pulse @sm:h-[250px]">
            <div className="space-y-3">
              <div className="h-6 w-[96%] rounded bg-[#F5F5FA]" />
              <div className="h-6 w-[92%] rounded bg-[#F5F5FA]" />
              <div className="hidden h-6 w-[98%] rounded bg-[#F5F5FA] @sm:block" />
              <div className="hidden h-6 w-[88%] rounded bg-[#F5F5FA] @sm:block" />
              <div className="hidden h-6 w-[75%] rounded bg-[#F5F5FA] @sm:block" />
            </div>
          </div>
        </div>
      </div>

      {/* Play + Download - mobile only, below editor */}
      <div className="flex w-full gap-2 @sm:hidden">
        <div className="h-12 flex-1 animate-pulse rounded-2xl bg-[#2F43FA]/20" />
        <div className="h-12 flex-1 animate-pulse rounded-2xl border border-[#E9EAF0] bg-[#F5F5FA]" />
      </div>

      {/* Bottom row: language selector + style selector (desktop only) */}
      <div className="hidden items-start gap-2 @sm:flex @lg:items-center">
        <div className="h-[52px] w-[180px] animate-pulse rounded-2xl bg-[#F5F5FA]" />
        <div className="h-[22px] w-px self-center bg-[#F5F5FA]" />
        <div className="flex min-w-0 flex-1 gap-2 py-1">
          <div className="h-[52px] w-[120px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:w-[140px]" />
          <div className="h-[52px] w-[120px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:w-[140px]" />
          <div className="hidden h-[52px] w-[140px] animate-pulse rounded-2xl bg-[#F5F5FA] @sm:block" />
        </div>
      </div>
    </div>
  );
};
